<script setup>
import { isEmpty } from 'lodash'

defineProps({
  id: {
    type: String,
    required: true,
  },
  totalsObject: {
    type: Object,
    required: true,
  },
  activeEmailDomainGiftingDiscount: {
    type: Object,
    required: true,
    default: null,
  },
  subtotal: {
    type: Number,
    required: false,
    default: null,
  },
  showPlaceOrderButton: {
    type: Boolean,
    required: false,
    default: false,
  },
  errors: {
    type: Array,
    required: false,
    default() {
      return []
    },
  },
})
const { $config } = useNuxtApp()
const layout = useLayout()
const emit = defineEmits(['placeOrder'])

const displayURL = computed(() => {
  return $config.public.baseUrl.replace(/^https?:\/\//i, '')
})
</script>

<template>
  <div>
    <div :id="id" class="checkout-summary-totals">
      <ul>
        <li>
          <span>Gift Total</span>
          <span>
            <Price
              v-if="!isEmpty(totalsObject) || subtotal"
              :amt="Number(subtotal || totalsObject.subtotal)"
            />
            <span v-else>-</span>
          </span>
        </li>
        <li
          v-if="!isEmpty(totalsObject) && totalsObject.discount_amount > 0"
          class="color-discount"
        >
          <span>
            {{ totalsObject.discount_name }}
          </span>
          <span
            >-<Price
              v-if="!isEmpty(totalsObject)"
              :amt="Number(totalsObject.discount_amount)"
            /><span v-else>-</span>
          </span>
        </li>
        <li
          v-else-if="!isEmpty(activeEmailDomainGiftingDiscount)"
          class="color-discount"
        >
          <span>
            {{ activeEmailDomainGiftingDiscount.name }}
          </span>
          <span>-</span>
        </li>
        <li>
          <span>Estimated Tax</span>
          <span
            ><Price
              v-if="!isEmpty(totalsObject) && totalsObject.taxes !== undefined"
              :amt="Number(totalsObject.taxes)"
            />
            <span v-else>-</span>
          </span>
        </li>
        <li v-if="!isEmpty(totalsObject) && totalsObject.single_surcharge > 0">
          <span>Service Fee</span>
          <span>
            <span>
              <Price :amt="Number(totalsObject.single_surcharge)" /> per
              shipment</span
            >
          </span>
        </li>
        <li>
          <span>Shipping</span>
          <span>
            <span
              v-if="
                !isEmpty(totalsObject) && totalsObject.shipping !== undefined
              "
              ><Price
                v-if="totalsObject.shipping > 0"
                :amt="Number(totalsObject.shipping)"
              /><span v-else>Included</span></span
            ><span v-else>-</span>
          </span>
        </li>
      </ul>
      <h3>
        <span>TOTAL</span>
        <span
          ><Price
            v-if="
              !isEmpty(totalsObject) && totalsObject.grand_total !== undefined
            "
            :amt="Number(totalsObject.grand_total)"
          /><span v-else>-</span>
        </span>
      </h3>
      <span v-if="showPlaceOrderButton && !isEmpty(totalsObject)">
        <br />
        <button class="max place-order" @click="emit('placeOrder')">
          Place Order
        </button>
        <p class="form-instructions">
          <em
            >By clicking Place Order I understand and agree to the
            <a
              target="_blank"
              class="underline"
              href="#"
              @click.prevent="layout.showTermsAndConditions = true"
              >Terms and Conditions</a
            ><br /><br />
            Please note: All sales are final. Your credit card will be charged
            at the time of purchase.
          </em>
        </p>
        <ErrorList :errors="errors" />
      </span>
    </div>
    <div class="checkout-summary-contact">
      <p class="head">Looking to gift multiple clubs?</p>
      <p>
        Email Us:
        <strong><CustomerServiceClubEmailLink /></strong>
      </p>
      <p>
        Call Us:
        <CustomerServicePhoneLink :use-bold="true" :with-hours-short="true" />
      </p>
      <slot name="disclosures">
        <p class="disclosures">
          Must be 21+ and US resident to give or receive a Gift Subscription.
          Not available for residents of Alabama, Alaska, Arkansas, Hawaii,
          Michigan, Mississippi, or Utah. Gift Subscriptions cannot be shipped
          to a PO Box. Someone 21 years or older must be available to sign for
          delivery. Giftee must accept subscription and create a free account
          with WineAccess within 6 months. If Giftee fails to respond or does
          not accept the Gift Subscription, in full or in part, value may be
          issued to either the original payment method used to purchase the
          subscription or in the form of a WineAccess gift card to Gifter. VOID
          WHERE PROHIBITED. Shipping in continental US and taxes are included in
          the cost of the Gift Subscription. WineAccess gift cards and discount
          codes cannot be applied to purchase of Gift Subscription. Full terms
          and conditions available at
          <a href="#" @click.prevent="layout.showTermsAndConditions = true"
            >{{ displayURL }}/terms/</a
          >.
        </p>
      </slot>
    </div>
  </div>
</template>
